import * as React from "react";
import ProductDetailContent from "./ProductDetail/ProductDetailContent";

export function ProductDetail() {
  return (
    <>
      <div className="logged-screen">
        <ProductDetailContent />
      </div>
    </>
  );
}
